import * as React from 'react'
import Router from 'next/router'
import Layout from '../components/share/Layout'
import { WEB_DOMAIN } from '../const/domain'
import { TinTucService, SettingService, HeaderService } from '../services'
import { getIDSeoUrl, formatUrlSeo, notFoundUrl } from '../util/seo-url'
import { NEWS } from '../const/seo-url'
import ContentComponent from '../components/share/ContentComponent'
import { CONTENT } from '../const/content'
import { loadImage } from '../util/image'
import { DanhMucUtil } from '../util/danhmuc'
import { PageTransition } from "next-page-transitions";
import TinLienQuan from '../components/tin-tuc/TinLienQuan'
import { DANH_MUC } from '../const/danh-muc';

function submitComment(tinTucId, comment) {
  return TinTucService.addComment(tinTucId, comment)
}

interface Props {
  domain
  title
  layoutProps
  numViewRandom
  tinTuc
}

interface State { }

export default class MegastoryDetail extends React.Component<any, any> {
  constructor(props) {
    super(props)
  }

  static async getInitialProps({ req, query }) {
    const layoutProps = await Layout.getInitialProps()
    const title = await SettingService.getSetting('title_tin_tuc')
    const host = req?.headers?.host || ''
    const protocol = (req as any)?.protocol || (req?.headers?.['x-forwarded-proto'] as string) || 'http'
    const originalUrl = (req as any)?.originalUrl || req?.url || ''
    let domain = `${protocol}://${host}${originalUrl}`

    let { url } = query
    if (!url || isNaN(Number(getIDSeoUrl(url))) || !getIDSeoUrl(url)) {
      return notFoundUrl(req);
    }
    const result = await TinTucService.getNewsByID(getIDSeoUrl(url))
    let tinTuc
    if (!result) {
      return notFoundUrl(req);
    } else {
      tinTuc = result.tinTuc
    }

    return {
      tinTuc,
      domain: domain,
      title: title.value.value,
      layoutProps,
      numViewRandom: Math.floor(Math.random() * (500 + 9000) + 500),
    }
  }


  /**
   * Lấy style theo danh mục
   */
  styleByDanhMuc(danhMucId) {
    if (danhMucId == DANH_MUC.MEGESTORY) {
      return (
        <style jsx global>
          {`
            #headerghim, .menu-desktop, .menu-fix {
              display:none  !important;
            }
              .block,.container {
                    width: 100%  !important;
                    max-width: 100%  !important;
                }
                .news-content img {
                    width: 100% !important;
                    height: auto !important;
                }
                blockquote {
                    padding: 10px;
                    margin: 0px auto !important;;
                    font-size: inherit;
                    border-left: 0;
                    max-width: 700px;
                    text-align: justify;
                }
                blockquote > img {
                    max-width: 700px !important;
                }
                .content-block {
                    padding: 0;
                    background: initial;
                }
                .no-padding-home {
                    padding: 0;
                }
                .image-right {
                    float:right; 
                    margin-left:40px; 
                    margin-right:-260px
                }
                .image-left {
                    float:left; 
                    margin-right:40px; 
                    margin-left:-260px
                }
                .header-back {
                    color: #fff;
                    width: 100px;
                    text-align: center;
                    float: right;
                    cursor: pointer;
                }
                .header-back:hover {
                    background: #ff1f1a;
                    color: #fded3b;
                }
                @media screen and (max-width: 767px) {
                    .image-right {
                        float: inherit;
                        margin-left: 0;
                        margin-right: 0;
                    }
                    .image-left {
                        float:inherit; 
                        margin-right:0; 
                        margin-left:-0
                    }
                    
                }
              `}
        </style>
      )
    }
  }

  render() {
    let { tinTuc, domain } = this.props
    let url_seo_danh_muc = ''
    let tenDanhMuc = DanhMucUtil.getsNameByID(tinTuc.danhMucTinID, tinTuc.danhMucTen)

    if (tinTuc) {
      url_seo_danh_muc = formatUrlSeo(tenDanhMuc, tinTuc.danhMucTinID)
    }
    return (
      <React.Fragment>
        {!tinTuc ? (
          this.renderNotFound()
        ) : (
          <Layout
            title={`${this.props.title} - ${tinTuc.tieuDe}`}
            seo={tinTuc.seo}
            {...this.props.layoutProps}
          >
            {/* <PageTransition timeout={400} classNames="page-transition"> */}

              <div className="block back-tintuc p-0" id="contentnews">
                <div className="container p-0">
                  <div className="row p-3" style={{ background: " #222222" }}>
                    <div className="col-sm-2 "> <h5 className="m-0"><a href="/" className="text-white text-bold">TRANG CHỦ</a></h5> </div>
                    <div className="col-sm-8 text-center">  <h5 className="m-0"><a href="/megastory" className="text-white text-bold"> MEGASTORY </a></h5></div>
                    <div className="col-sm-2 nopadding"> <a className="header-back wow slideInLeft animated animated animated" href="" style={{ visibility: "visible", animationName: "slideInLeft" }}> <i className="fa fa-arrow-right fa-2" aria-hidden="true"></i> </a></div>
                  </div>
                  <div
                    className="news-content"
                    dangerouslySetInnerHTML={{ __html: tinTuc.noiDung }}
                  />
                  <TinLienQuan tin_tuc_id={tinTuc.id} danh_muc={tinTuc.danhMucTinID} />
                </div>

              </div>

            {/* </PageTransition> */}

            {this.styleByDanhMuc(tinTuc.danhMucTinID)}
            <style jsx global>
              {`
                .page-transition-enter {
                  opacity: 0;
                }
                .page-transition-enter-active {
                  opacity: 1;
                  transition: opacity ${400}ms;
                }
                .page-transition-exit {
                  opacity: 1;
                }
                .page-transition-exit-active {
                  opacity: 0;
                  transition: opacity ${400}ms;
                }
              `}
            </style>

          </Layout>
        )}
      </React.Fragment>
    )
  }

  public renderNotFound = () => {
    return (
      <Layout title={this.props.title} {...this.props.layoutProps}>
        <h1>Tin bạn tìm kiếm không tồn tại</h1>
      </Layout>
    )
  }
}
